import { render } from "./DirectOnboardingModal.vue?vue&type=template&id=4ae18623&scoped=true"
import script from "./DirectOnboardingModal.vue?vue&type=script&lang=js"
export * from "./DirectOnboardingModal.vue?vue&type=script&lang=js"

import "./DirectOnboardingModal.vue?vue&type=style&index=0&id=4ae18623&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae18623"]])

export default __exports__